import handler from 'api/handler'

const prefix = '/admin/blog'

const methods = {
  update: args => handler({ method: 'put', url: prefix + '/update', args, isFile: true }),
  fetch: args => handler({ method: 'get', url: prefix + '/fetch', args })
}

export default methods
